import ReduxProtectedSidebar from './redux-protected-sidebar';

export default ReduxProtectedSidebar;